import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AppAppBar from '../AppAppBar';
import Footer from '../Footer';

export default function Imprint({ mode, toggleColorMode }) {
  return (
    <React.Fragment>
      <AppAppBar mode={mode} toggleColorMode={toggleColorMode} />
      <Container 
        component="main" 
        sx={{ 
          mt: { xs: 12, md: 14 }, 
          mb: { xs: 12, md: 14 },
          px: { xs: 2, sm: 3, md: 4 }
        }} 
        maxWidth="lg"
      >
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Impressum
          </Typography>
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            Angaben gemäß § 5 TMG
          </Typography>
          <Typography variant="body1" paragraph>
            Muster GmbH
            <br />
            Musterstraße 123
            <br />
            12345 Musterstadt
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            Vertreten durch
          </Typography>
          <Typography variant="body1" paragraph>
            Max Mustermann
            <br />
            Geschäftsführer
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            Kontakt
          </Typography>
          <Typography variant="body1" paragraph>
            Telefon: +49 (0) 123 456789
            <br />
            E-Mail: info@example.com
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            Registereintrag
          </Typography>
          <Typography variant="body1" paragraph>
            Eintragung im Handelsregister
            <br />
            Registergericht: Amtsgericht Musterstadt
            <br />
            Registernummer: HRB 12345
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            Umsatzsteuer-ID
          </Typography>
          <Typography variant="body1" paragraph>
            Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
            <br />
            DE 123456789
          </Typography>
        </Box>
      </Container>
      <Footer />
    </React.Fragment>
  );
}